import React, { useState } from "react";
import { IForm } from "../../../../types/form.type";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { useForm } from "react-hook-form";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import ModalForm from "../../modal/ModalForm";
import { Stack } from "@mui/material";
import moment from "moment";
import InfoSection from "./info-section/InfoSection";
import DetailsSection from "./details-section/DetailsSection";
import DescriptionSection from "./description-section/DescriptionSection";

const schema = yup.object({
  kho: yup
    .object()
    .typeError("Vui lòng chọn kho")
    .required("Vui lòng chọn kho"),
  ngay_ct: yup
    .date()
    .typeError("Vui lòng nhập ngày chứng từ")
    .required("Vui lòng nhập ngày chứng từ"),
  nha_cung_cap: yup
    .object()
    .typeError("Vui lòng chọn nhà cung cấp")
    .required("Vui lòng chọn nhà cung cấp"),
  trang_thai: yup
    .object()
    .typeError("Vui lòng chọn trạng thái")
    .required("Vui lòng chọn trạng thái"),
});

function FormPN1({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const { showAlert } = useAlertContext();
  const defaultData: { [key: string]: any } = {
    so_ct: "",
    ngay_ct: moment().format("YYYY-MM-DD HH:mm"),
    kho: null,
    trang_thai: null,
    nha_cung_cap: null,
    tk_co: "331111",
  };
  const originData = defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
        kho: {
          ma_kho: defaultValues?.ma_kho,
          ten_kho: defaultValues?.ten_kho,
        },
        nha_cung_cap: defaultValues.ma_kh
          ? {
              ma_kh: defaultValues?.ma_kh,
              ten_kh: defaultValues?.ten_kh,
            }
          : null,
        nhan_vien: defaultValues.ma_nv
          ? { ma_nv: defaultValues.ma_nv, ten_nv: defaultValues.ten_nv }
          : null,
        // pttt: defaultValues.hinh_thuc_tt
        //   ? pttts.find((item) => item._id === defaultValues.hinh_thuc_tt)
        //   : null,
        ngay_ct: moment(defaultValues.ngay_ct).format("YYYY-MM-DD HH:mm"),
        trang_thai: defaultValues.trang_thai
          ? {
              ma_trang_thai: defaultValues.trang_thai,
              ten_trang_thai: defaultValues.ten_trang_thai,
            }
          : null,
      }
    : defaultData;

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });
  const [details, setDetails] = useState<any[]>(defaultValues?.details || []);

  const handleReset = () => {
    reset(originData);
    setDetails(defaultValues?.details || []);
  };

  const generateDataPost = async (values: typeof defaultData) => {
    const { kho, nha_cung_cap, trang_thai, nhan_vien, pttt, ...data } = values;
    const result = {
      ...data,
      ma_kho: kho?.ma_kho || "",
      ten_kho: kho?.ten_kho || "",
      ma_kh: nha_cung_cap?.ma_kh || "",
      ten_kh: nha_cung_cap?.ten_kh || "",
      trang_thai: trang_thai?.ma_trang_thai || "",
      ten_trang_thai: trang_thai?.ten_trang_thai || "",
      ma_nv: nhan_vien?.ma_nv || "",
      ten_nv: nhan_vien?.ten_nv || "",
      hinh_thuc_tt: pttt?._id || "",
      ten_hinh_thuc_tt: pttt?.ten || "",
      details,
    };
    return result;
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost: { [key: string]: any } = await generateDataPost(values);
    let resp = null;
    if (isEdit) {
      resp = await asyncPutData({
        id: dataPost._id,
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    } else {
      resp = await asyncPostData({
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    }
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi lưu đối tượng",
      });
    } else {
      onClose();
      setLoad?.((prev: number) => prev + 1);
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="1000px"
      formTitle="phiếu nhập hàng"
      loading={isSubmitting}
      open={open}
      isEdit={isEdit}
      onClose={onClose}
      onSubmit={onSubmit}
      onReset={handleReset}
    >
      <Stack gap={2}>
        <InfoSection register={register} control={control} errors={errors} />
        <DetailsSection details={details} setDetails={setDetails} />
        <DescriptionSection register={register} />
      </Stack>
    </ModalForm>
  );
}

export default FormPN1;
